import { memo } from "react";
import PrimeBadge from "../../../../../../components/primeBadge/PrimeBadge";
import UserAvatar from "../../../../../../components/userAvatar/UserAvatar";
import { formatFullStamp, formatListStamp } from "../../../../../../utils/chatTime";
import styles from "./oneChat.module.css";

// One conversation in the list: the player, when they last talked, the last
// message (support's own marked), and the unread count.
const OneChat = ({ chat, isActive, onOpen, timeZone }) => {
  const player = chat.userId;
  const unread = chat.unreadByAdminCount || 0;
  const lastAt = chat.lastMessageAt ? new Date(chat.lastMessageAt) : null;
  // lastSenderId is the player (populated or a bare id) or support (null or
  // an admin's id).
  const lastSender = chat.lastSenderId?._id ?? chat.lastSenderId;
  const fromSupport =
    Boolean(chat.lastMessage) && String(lastSender) !== String(player?._id);

  const className = [styles.row, isActive && styles.active, unread > 0 && styles.unread]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={className}
      onClick={() => onOpen(chat)}
      aria-current={isActive ? "true" : undefined}
    >
      <span className={styles.avatar}>
        <UserAvatar src={player?.userImage?.path} alt="" />
      </span>
      <span className={styles.body}>
        <span className={styles.topLine}>
          <span className={styles.name} dir="auto">
            {player?.name || "لاعب"}
          </span>
          <PrimeBadge
            isPrime={player?.isPrime}
            primeTier={player?.primeTier}
            size="small"
            className={styles.badge}
          />
          {lastAt && (
            <time
              className={styles.time}
              dateTime={chat.lastMessageAt}
              title={formatFullStamp(lastAt, timeZone)}
            >
              {formatListStamp(lastAt, timeZone)}
            </time>
          )}
        </span>
        <span className={styles.bottomLine}>
          <span className={styles.preview}>
            {fromSupport && <span className={styles.previewAuthor}>الدعم:</span>}
            {/* Its own direction, so an English message is cut at its end. */}
            <span className={styles.previewText} dir="auto">
              {chat.lastMessage || "لا توجد رسائل"}
            </span>
          </span>
          {unread > 0 && (
            <span className={styles.count} aria-label={`${unread} غير مقروءة`}>
              {unread > 99 ? "99+" : unread}
            </span>
          )}
        </span>
      </span>
    </button>
  );
};

export default memo(OneChat);
